export default {"src":"https://static.eleduck.com/_next/static/media/medal-2.d5ab7d25.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};